// ============================================================
// Religion, Category & Caste Demographics Master Data
// ============================================================

export const RELIGION_DEMOGRAPHICS_DATA = {
  religions: [
    {
      name: "Hindu",
      aliases: ["Hinduism", "HINDU"],
      categories: [
        {
          name: "General",
          castes: [
            "Brahmin",
            "Rajput",
            "Bhumihar",
            "Kayastha",
            "Vaishya",
            "Agarwal",
            "Bania",
            "Khatri",
            "Arora",
            "Mahajan",
            "Marwari",
            "Punjabi",
            "Thakur",
            "Tyagi",
            "Saraswat",
            "Nagar",
            "Deshastha",
            "Chitpavan",
            "Namboodiri",
            "Iyer",
            "Iyengar",
            "Gaur Brahmin",
            "Kanyakubja Brahmin",
            "Saryuparin Brahmin",
            "Maithil Brahmin",
            "Gupta",
            "Khandelwal",
            "Maheshwari",
            "Kshatriya",
            "Nair",
            "Pillai",
            "Reddy",
            "Kamma",
            "Vokkaliga",
            "Maratha"
          ]
        },
        {
          name: "OBC",
          castes: [
            "Yadav",
            "Ahir",
            "Kurmi",
            "Patel",
            "Koeri",
            "Kushwaha",
            "Maurya",
            "Shakya",
            "Saini",
            "Lodhi",
            "Jat",
            "Gujjar",
            "Gurjar",
            "Teli",
            "Kumhar",
            "Prajapati",
            "Sonar",
            "Sunar",
            "Kahar",
            "Kevat",
            "Kewat",
            "Mali",
            "Pal",
            "Gadaria",
            "Nai",
            "Barber",
            "Lonia",
            "Kandu",
            "Tamboli",
            "Halwai",
            "Kasar",
            "Bhar",
            "Kalwar",
            "Vishwakarma",
            "Gounder",
            "Thevar",
            "Lingayat",
            "Vanjari"
          ]
        },
        {
          name: "SC",
          castes: [
            "Chamar",
            "Jatav",
            "Pasi",
            "Dhobi",
            "Kori",
            "Valmiki",
            "Balmiki",
            "Dom",
            "Mochi",
            "Khatik",
            "Mahar",
            "Mang",
            "Madiga",
            "Mala",
            "Satnami",
            "Bhangi",
            "Mehtar",
            "Halalkhor",
            "Lalbegi",
            "Ravidas",
            "Charmakar",
            "Koli",
            "Ravidasia"
          ]
        },
        {
          name: "ST",
          castes: [
            "Gond",
            "Bhil",
            "Santhal",
            "Munda",
            "Oraon",
            "Tharu",
            "Ho",
            "Kharia",
            "Baiga",
            "Bodo",
            "Khasi",
            "Garo",
            "Naga",
            "Korku",
            "Koya",
            "Kol",
            "Bhutia",
            "Toda",
            "Lepcha",
            "Jarawa"
          ]
        },
        {
          name: "EWS",
          castes: [
            "General EWS",
            "Brahmin EWS",
            "Rajput EWS",
            "Vaishya EWS",
            "Kayastha EWS"
          ]
        }
      ]
    },
    {
      name: "Muslim",
      aliases: ["Islam", "MUSLIM"],
      categories: [
        {
          name: "General",
          castes: [
            "Syed",
            "Sheikh",
            "Pathan",
            "Mughal",
            "Mirza",
            "Khan",
            "Siddiqui"
          ]
        },
        {
          name: "OBC",
          castes: [
            "Ansari",
            "Qureshi",
            "Mansoori",
            "Saifi",
            "Julaha",
            "Rayeen",
            "Faqir",
            "Dhunia",
            "Idrisi",
            "Salmani",
            "Bohra",
            "Memon"
          ]
        },
        {
          name: "SC",
          castes: [
            "Halalkhor",
            "Lalbegi",
            "Bhangi"
          ]
        },
        {
          name: "ST",
          castes: [
            "Gujjar Muslim",
            "Gaddi Muslim"
          ]
        },
        {
          name: "Ashraf",
          castes: [
            "Syed",
            "Sheikh",
            "Pathan",
            "Mughal",
            "Mirza"
          ]
        },
        {
          name: "Ajlaf",
          castes: [
            "Ansari",
            "Qureshi",
            "Mansoori",
            "Saifi",
            "Julaha",
            "Rayeen",
            "Faqir",
            "Dhunia",
            "Idrisi",
            "Salmani"
          ]
        },
        {
          name: "Arzal",
          castes: [
            "Halalkhor",
            "Lalbegi",
            "Bhangi"
          ]
        }
      ]
    },
    {
      name: "Christian",
      aliases: ["Christianity", "CHRISTIAN"],
      categories: [
        {
          name: "General",
          castes: [
            "Roman Catholic",
            "Protestant",
            "Orthodox",
            "CSI",
            "CNI",
            "Pentecostal",
            "Baptist",
            "Lutheran",
            "Methodist",
            "Latin Catholic",
            "Syro Malabar",
            "Syro Malankara",
            "Anglo-Indian",
            "Syrian Christian"
          ]
        },
        {
          name: "OBC",
          castes: [
            "Latin Catholic OBC",
            "Converted Christian OBC"
          ]
        },
        {
          name: "SC",
          castes: [
            "Dalit Christian",
            "Scheduled Caste Converted Christian"
          ]
        },
        {
          name: "Denomination",
          castes: [
            "Roman Catholic",
            "Protestant",
            "Orthodox",
            "CSI",
            "CNI",
            "Pentecostal",
            "Baptist",
            "Lutheran",
            "Methodist",
            "Latin Catholic",
            "Syro Malabar",
            "Syro Malankara"
          ]
        }
      ]
    },
    {
      name: "Sikh",
      aliases: ["Sikhism", "SIKH"],
      categories: [
        {
          name: "General",
          castes: [
            "Jat Sikh",
            "Khatri",
            "Arora",
            "Ahluwalia"
          ]
        },
        {
          name: "OBC",
          castes: [
            "Ramgarhia",
            "Lubana",
            "Bhatra",
            "Nanakpanthi"
          ]
        },
        {
          name: "SC",
          castes: [
            "Mazhabi",
            "Mazhabi Sikh",
            "Ravidasia Sikh"
          ]
        },
        {
          name: "Community",
          castes: [
            "Jat Sikh",
            "Khatri",
            "Arora",
            "Ramgarhia",
            "Mazhabi",
            "Lubana",
            "Bhatra",
            "Nanakpanthi"
          ]
        }
      ]
    },
    {
      name: "Buddhist",
      aliases: ["Buddhism", "BUDDHIST"],
      categories: [
        {
          name: "General",
          castes: [
            "Tibetan Buddhist",
            "Theravada",
            "Mahayana"
          ]
        },
        {
          name: "SC",
          castes: [
            "Neo Buddhist",
            "Navayana",
            "Mahar Buddhist"
          ]
        },
        {
          name: "ST",
          castes: [
            "Chakma",
            "Ladakhi Buddhist"
          ]
        },
        {
          name: "Community",
          castes: [
            "Neo Buddhist",
            "Navayana",
            "Tibetan Buddhist"
          ]
        }
      ]
    },
    {
      name: "Jain",
      aliases: ["Jainism", "JAIN"],
      categories: [
        {
          name: "General",
          castes: [
            "Digambar",
            "Shwetambar",
            "Sthanakvasi",
            "Terapanthi",
            "Oswal",
            "Porwal"
          ]
        },
        {
          name: "Sect",
          castes: [
            "Digambar",
            "Shwetambar",
            "Sthanakvasi",
            "Terapanthi"
          ]
        }
      ]
    },
    {
      name: "Parsi",
      aliases: ["Zoroastrianism", "Zoroastrian", "PARSI"],
      categories: [
        {
          name: "General",
          castes: [
            "Zoroastrian",
            "Irani",
            "Parsi"
          ]
        },
        {
          name: "Community",
          castes: [
            "Zoroastrian"
          ]
        }
      ]
    },
    {
      name: "Tribal",
      aliases: ["TRIBAL", "Adivasi"],
      categories: [
        {
          name: "ST",
          castes: [
            "Sarna",
            "Sanamahi",
            "Donyi Polo",
            "Nature Religion",
            "Animist",
            "Heraka",
            "Songsarek"
          ]
        },
        {
          name: "Community",
          castes: [
            "Sarna",
            "Sanamahi",
            "Donyi Polo",
            "Nature Religion",
            "Animist",
            "Heraka",
            "Songsarek"
          ]
        }
      ]
    },
    {
      name: "Other",
      aliases: ["OTHER"],
      categories: [
        {
          name: "General",
          castes: [
            "Bahai",
            "Judaism",
            "Atheist",
            "None",
            "Other"
          ]
        },
        {
          name: "Community",
          castes: [
            "Bahai",
            "Judaism",
            "Atheist",
            "None",
            "Other"
          ]
        }
      ]
    }
  ]
};

// Standard Categories fallback list
export const STANDARD_CATEGORIES = ["General", "OBC", "SC", "ST", "EWS", "Other"];

/**
 * Normalizes a religion string to match canonical name in master data
 */
export function normalizeReligionName(input) {
  if (!input) return "";
  const trimmed = String(input).trim();
  const lower = trimmed.toLowerCase();
  for (const rel of RELIGION_DEMOGRAPHICS_DATA.religions) {
    if (rel.name.toLowerCase() === lower) return rel.name;
    if (rel.aliases && rel.aliases.some(a => a.toLowerCase() === lower)) return rel.name;
  }
  return trimmed;
}

/**
 * Returns list of primary Religion names
 */
export function getReligions() {
  return RELIGION_DEMOGRAPHICS_DATA.religions.map(r => r.name);
}

/**
 * Returns categories available for a given religion.
 * Merges standard categories (General, OBC, SC, ST, EWS) with specific sub-categories.
 */
export function getCategoriesForReligion(religionName) {
  if (!religionName) return STANDARD_CATEGORIES;
  
  const canonical = normalizeReligionName(religionName);
  const found = RELIGION_DEMOGRAPHICS_DATA.religions.find(r => r.name.toLowerCase() === canonical.toLowerCase());
  
  if (!found) return STANDARD_CATEGORIES;
  
  const catNames = found.categories.map(c => c.name);
  const combined = Array.from(new Set([...STANDARD_CATEGORIES, ...catNames]));
  return combined;
}

/**
 * Returns castes for a given religion and category combination.
 */
export function getCastesForReligionAndCategory(religionName, categoryName) {
  if (!religionName && !categoryName) return getAllCastes();

  const canonicalRel = normalizeReligionName(religionName);
  const relObj = RELIGION_DEMOGRAPHICS_DATA.religions.find(r => r.name.toLowerCase() === canonicalRel.toLowerCase());

  let matchingCastes = [];

  if (relObj) {
    if (categoryName) {
      const catLower = String(categoryName).trim().toLowerCase();
      const catObj = relObj.categories.find(c => c.name.toLowerCase() === catLower);
      if (catObj && Array.isArray(catObj.castes)) {
        matchingCastes = catObj.castes;
      }
    }

    // If no specific category match found under this religion, collect all castes for this religion
    if (matchingCastes.length === 0) {
      relObj.categories.forEach(c => {
        if (Array.isArray(c.castes)) {
          matchingCastes.push(...c.castes);
        }
      });
    }
  } else if (categoryName) {
    // If religion is not matched, search across all religions for this category name
    const catLower = String(categoryName).trim().toLowerCase();
    RELIGION_DEMOGRAPHICS_DATA.religions.forEach(r => {
      const catObj = r.categories.find(c => c.name.toLowerCase() === catLower);
      if (catObj && Array.isArray(catObj.castes)) {
        matchingCastes.push(...catObj.castes);
      }
    });
  }

  // Deduplicate and return
  const uniqueCastes = Array.from(new Set(matchingCastes));
  return uniqueCastes.length > 0 ? uniqueCastes : getAllCastes();
}

/**
 * Returns a deduplicated list of all castes across all religions and categories
 */
export function getAllCastes() {
  const all = [];
  RELIGION_DEMOGRAPHICS_DATA.religions.forEach(r => {
    r.categories.forEach(c => {
      if (Array.isArray(c.castes)) {
        all.push(...c.castes);
      }
    });
  });
  return Array.from(new Set(all)).sort((a, b) => a.localeCompare(b));
}
